function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.84023 2.81999H3.68023C3.20527 2.81999 2.82023 3.20503 2.82023 3.67999V8.83999C2.82023 9.31495 3.20527 9.69999 3.68023 9.69999H8.84023C9.3152 9.69999 9.70023 9.31495 9.70023 8.83999V3.67999C9.70023 3.20502 9.3152 2.81999 8.84023 2.81999ZM3.68023 0.23999C1.78037 0.23999 0.240234 1.78013 0.240234 3.67999V8.83999C0.240234 10.7398 1.78037 12.28 3.68023 12.28H8.84023C10.7401 12.28 12.2802 10.7398 12.2802 8.83999V3.67999C12.2802 1.78013 10.7401 0.23999 8.84023 0.23999H3.68023Z",
  fill: "currentColor"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.3207 2.81999H19.1607C18.6857 2.81999 18.3007 3.20503 18.3007 3.67999V8.83999C18.3007 9.31495 18.6857 9.69999 19.1607 9.69999H24.3207C24.7957 9.69999 25.1807 9.31495 25.1807 8.83999V3.67999C25.1807 3.20502 24.7957 2.81999 24.3207 2.81999ZM19.1607 0.23999C17.2608 0.23999 15.7207 1.78013 15.7207 3.67999V8.83999C15.7207 10.7398 17.2608 12.28 19.1607 12.28H24.3207C26.2206 12.28 27.7607 10.7398 27.7607 8.83999V3.67999C27.7607 1.78013 26.2206 0.23999 24.3207 0.23999H19.1607Z",
  fill: "currentColor"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.84023 18.3H3.68023C3.20527 18.3 2.82023 18.685 2.82023 19.16V24.32C2.82023 24.7949 3.20527 25.18 3.68023 25.18H8.84023C9.3152 25.18 9.70023 24.7949 9.70023 24.32V19.16C9.70023 18.685 9.3152 18.3 8.84023 18.3ZM3.68023 15.72C1.78037 15.72 0.240234 17.2601 0.240234 19.16V24.32C0.240234 26.2198 1.78037 27.76 3.68023 27.76H8.84023C10.7401 27.76 12.2802 26.2198 12.2802 24.32V19.16C12.2802 17.2601 10.7401 15.72 8.84023 15.72H3.68023Z",
  fill: "currentColor"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.3207 18.3H19.1607C18.6857 18.3 18.3007 18.685 18.3007 19.16V24.32C18.3007 24.7949 18.6857 25.18 19.1607 25.18H24.3207C24.7957 25.18 25.1807 24.7949 25.1807 24.32V19.16C25.1807 18.685 24.7957 18.3 24.3207 18.3ZM19.1607 15.72C17.2608 15.72 15.7207 17.2601 15.7207 19.16V24.32C15.7207 26.2198 17.2608 27.76 19.1607 27.76H24.3207C26.2206 27.76 27.7607 26.2198 27.7607 24.32V19.16C27.7607 17.2601 26.2206 15.72 24.3207 15.72H19.1607Z",
  fill: "currentColor"
});

var SvgGeneral = function SvgGeneral(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGeneral, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/general.9bd28229.svg";
export { ForwardRef as ReactComponent };